import { render, staticRenderFns } from "./AddGroupModal.vue?vue&type=template&id=03b39b41&scoped=true"
import script from "./AddGroupModal.vue?vue&type=script&lang=js"
export * from "./AddGroupModal.vue?vue&type=script&lang=js"
import style0 from "./AddGroupModal.vue?vue&type=style&index=0&id=03b39b41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b39b41",
  null
  
)

export default component.exports